module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingAdd),
      expression: "loadingAdd"
    }],
    staticClass: "left",
    class: {
      'left-cashier': _vm.isCashier
    }
  }, [_c('div', {
    staticClass: "heard",
    attrs: {
      "id": "goodsList"
    }
  }, [_c('div', {
    staticClass: "input"
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "text",
      "size": "medium",
      "border-radius": "0",
      "placeholder": "扫码条形码或输入关键字"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.queryProject.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('span', {
    staticClass: "icon",
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_c('i', {
    staticClass: "el-icon-camera-solid"
  })])])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.queryProject
    }
  }, [_vm._v(_vm._s(_vm.queryText))]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabSelect),
      callback: function($$v) {
        _vm.tabSelect = $$v
      },
      expression: "tabSelect"
    }
  }, [(_vm.isShowGoods) ? _c('el-tab-pane', {
    attrs: {
      "name": "goods",
      "label": "商品"
    }
  }, [_vm._l((_vm.goodsCategoryList), function(items, index) {
    return _c('span', {
      key: index
    }, [_c('el-button', {
      staticClass: "pa_btn",
      class: index == _vm.goodsIndex ? 'on' : 'white',
      attrs: {
        "size": "small",
        "type": "FFF"
      },
      on: {
        "click": function($event) {
          return _vm.getGoodsList(index, items.category_id, items.childNode)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(items.category_name) + "\n\t\t\t\t\t\t\t")])], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, _vm._l((_vm.secondCategoryList), function(secondItem, secondIndex) {
    return _c('span', {
      key: secondIndex
    }, [_c('el-button', {
      staticClass: "pa_btn",
      class: secondIndex == _vm.secondGoodsIndex ? 'on' : 'white',
      attrs: {
        "size": "small",
        "type": "FFF"
      },
      on: {
        "click": function($event) {
          return _vm.secondGoodsList(secondIndex, secondItem.category_id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t " + _vm._s(secondItem.category_name) + "\n\t\t\t\t\t\t\t\t")])], 1)
  }), 0)], 2) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "service",
      "label": "服务"
    }
  }, _vm._l((_vm.serviceCategoryList), function(items, index) {
    return _c('span', {
      key: index
    }, [_c('el-button', {
      staticClass: "pa_btn",
      class: index == _vm.serviceIndex ? 'on' : 'white',
      attrs: {
        "size": "small",
        "type": "FFF"
      },
      on: {
        "click": function($event) {
          return _vm.getServiceList(index, items.category_id)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(items.category_name) + "\n\t\t\t\t\t\t\t")])], 1)
  }), 0)], 1)], 1)], 1), _vm._v(" "), (_vm.tabSelect === 'goods') ? _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "content",
    style: (_vm.goodslistheight),
    attrs: {
      "infinite-scroll-disabled": _vm.goodsDisabled
    }
  }, [_c('el-row', _vm._l((_vm.goodsList), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "xs": {
          span: 24,
          offset: 0
        },
        "sm": {
          span: 24,
          offset: 0
        },
        "md": {
          span: 12,
          offset: 0
        },
        "lg": {
          span: 6,
          offset: 0
        },
        "xl": {
          span: 4,
          offset: 0
        },
        "offset": index > 0 ? 2 : 0
      }
    }, [_c('span', {
      staticClass: "goods_list_box",
      class: {
        selStyle: item.appointment == '1'
      },
      on: {
        "click": function($event) {
          return _vm.selectGoodsItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_vm._v("售价：\n\t\t\t\t\t\t\t"), (item.goods_price_min == item.goods_price_max) ? _c('span', [_vm._v("¥" + _vm._s(item.goods_price_max))]) : _c('span', [_vm._v("¥" + _vm._s(item.goods_price_min) + "~" + _vm._s(item.goods_price_max))])])])])
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#FF700B",
      "margin-top": "30px"
    },
    attrs: {
      "align": "center"
    }
  }, [(_vm.loadingData) ? _c('p', {
    staticClass: "loadMust"
  }, [_vm._v("加载中...")]) : (_vm.noGoodsMore) ? _c('p', {
    staticClass: "loadMust"
  }, [_vm._v("没有更多了")]) : _vm._e()])], 1) : (_vm.tabSelect === 'service') ? _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "content",
    style: (_vm.goodslistheight),
    attrs: {
      "infinite-scroll-disabled": _vm.serviceDisabled
    }
  }, [_c('el-row', _vm._l((_vm.serviceList), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "xs": {
          span: 24,
          offset: 0
        },
        "sm": {
          span: 24,
          offset: 0
        },
        "md": {
          span: 12,
          offset: 0
        },
        "lg": {
          span: 6,
          offset: 0
        },
        "xl": {
          span: 4,
          offset: 0
        },
        "offset": index > 0 ? 2 : 0
      }
    }, [_c('span', {
      staticClass: "goods_list_box",
      class: {
        selStyle: item.appointment == '1'
      },
      on: {
        "click": function($event) {
          return _vm.selectGoodsItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.service_name))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_vm._v("售价：\n\t\t\t\t\t\t\t"), (item.service_price_min == item.service_price_max) ? _c('span', [_vm._v("¥" + _vm._s(item.service_price_max))]) : _c('span', [_vm._v("¥" + _vm._s(item.service_price_min) + "~" + _vm._s(item.service_price_max))])])])])
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#FF700B"
    },
    attrs: {
      "align": "center"
    }
  }, [(_vm.loadingData) ? _c('p', {
    staticClass: "loadMust"
  }, [_vm._v("加载中...")]) : (_vm.noServiceMore) ? _c('p', {
    staticClass: "loadMust"
  }, [_vm._v("没有更多了")]) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择规格",
      "width": "30%",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.cancelSelected
    }
  }, [_c('div', {
    staticClass: "showCon",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._l((_vm.selectItem.skuList), function(obj, key, sub) {
    return _c('dl', {
      key: sub,
      staticClass: "pa_select_sku_box",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('dd', {
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "margin-left": "5px",
        "margin-bottom": "5px"
      }
    }, [_vm._v(_vm._s(key) + "：")]), _vm._v(" "), _c('el-radio-group', {
      attrs: {
        "size": "small"
      },
      on: {
        "change": function($event) {
          return _vm.radioSkuTap(key, obj.arr)
        }
      },
      model: {
        value: (obj.arr),
        callback: function($$v) {
          _vm.$set(obj, "arr", $$v)
        },
        expression: "obj.arr"
      }
    }, _vm._l((obj), function(arr, aindex) {
      return _c('el-radio', {
        key: aindex,
        attrs: {
          "label": arr,
          "border": ""
        }
      }, [_vm._v(_vm._s(arr))])
    }), 1)], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "padding-top": "10px",
      "border-top": "solid 1px #e5e5e5"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "color": "#FF700B",
      "font-weight": "bold"
    }
  }, [_vm._v("\n\t\t\t\t\t￥" + _vm._s(_vm.selectedSkuPrice) + "\n\t\t\t\t")]), _vm._v(" "), (_vm.selectedSkuError) ? _c('div', [_vm._v(_vm._s(_vm.selectedSkuError))]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelSelected
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "FF7",
      "disabled": !_vm.btnAddFlag
    },
    on: {
      "click": _vm.submitSelected
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b1be244"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/selectProduct.vue
// module id = 3497
// module chunks = 103